import type { ChangelogEntry } from "../types";

/**
 * VIB-2705. Gjelder bare de som setter opp salgsdisplayet, derfor admin på
 * seksjonen, og flagget fordi hele slideoppsettet henger på det.
 */
export const SLIDE_PREVIEW_2026_09: ChangelogEntry = {
  id: "2026-09-30-slide-preview",
  date: "2026-09-30",
  title: "Se salgsdisplayet mens du setter det opp",
  summary:
    "Slideoppsettet viser nå hvordan skjermen faktisk blir, både hele loopen og den sliden du holder på å skrive. Før måtte du opp på en TV for å se resultatet.",
  sections: [
    {
      heading: "Innstillinger",
      minRole: "admin",
      items: [
        {
          title: "Hele loopen vises øverst i slideoppsettet, og du kan bla i den",
          kind: "nytt",
          body: "Du ser salgsdisplayet slik det faktisk blir, med ekte tall i widgetene, og kan bla til neste og forrige skjerm eller hoppe rett til en av dem. Den bytter ikke av seg selv, så du rekker å se på den du vurderer.",
        },
        {
          title: "En widget er flere skjermer, og nå står det hvor mange",
          kind: "forbedret",
          body: "«Hall of Fame» blir tre skjermer på TV-en og «Salgspuls + alle selgere» blir én per salgsenhet. Før så begge ut som én linje på 15 sekunder i lista. Nå teller loopen dem hver for seg, og oppsettet viser hvor lang hele runden er.",
        },
        {
          title: "Sliden du skriver vises ved siden av skjemaet",
          kind: "nytt",
          body: "Tittel, beskjed og bakgrunnsbilde dukker opp mens du skriver, i samme skrift og farger som på skjermen. Velger du en bildefil, ser du den før den er lastet opp.",
        },
        {
          title: "Egen adresse å sette opp salgsskjermene på",
          kind: "nytt",
          body: "Adressen står øverst i slideoppsettet, med en kopier-knapp. Åpnet på en skjerm viser den loopen i fullskjerm uten meny. Skjermen må logge inn én gang, så lar du den stå, og kontoen den logger inn med må ha Display i menyen. Vil du bare kikke inne i appen, finnes Salgsdisplay fortsatt under Display som før.",
        },
      ],
    },
  ],
};
